module.exports = __webpack_public_path__ + "static/media/loader_red.180975d5.gif";